import { ApiBase, ApiResponse } from '../api-base';
import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { GroupEntity } from './group-entity';

@inject(IHttpClient)
export class GroupsApi extends ApiBase {

    constructor(http: IHttpClient) {
        super(http);
    }

    public async add(eventId: string, entity: GroupEntity): Promise<GroupEntity> {
        const dto = entity.toDto();
        const response = await this.post(this._baseUrl(eventId), dto);
        return GroupEntity.fromDto(response.content);
    }

    public async update(eventId: string, id: string, entity: GroupEntity): Promise<GroupEntity> {
        const dto = entity.toDto();
        const response = await this.patch(this._baseUrl(eventId) + '/' + id, dto);
        return GroupEntity.fromDto(response.content);
    }

    public async getById(eventId: string, id: string): Promise<GroupEntity> {
        const response = await this.get(this._baseUrl(eventId) + '/' + id);
        return GroupEntity.fromDto(response.content);
    }

    public async listByEventId(eventId: string): Promise<GroupEntity[]> {
        const response = await this.get(this._baseUrl(eventId));
        return GroupEntity.fromDtoArray(response.content);
    }

    public async deleteById(eventId: string, id: string): Promise<ApiResponse> {
        const response = await this.delete(this._baseUrl(eventId) + '/' + id);
        return response.content;
    }

    private _baseUrl(eventId: string): string {
        return `api/events/${eventId}/groups`;
    }
}
